import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const sectionStyles = ({ theme }) => css`
  label: summary__section;

  margin-bottom: ${theme.spacings.kilo};
  justify-content: space-between;
  display: flex;

  &:last-child {
    margin-bottom: 0;
  }
`

const discountTextStyles = ({ theme }) => css`
  label: text--discount;

  color: ${theme.colors.p500};
`

const wrapperStyles = ({ theme }) => css`
  label: summary__wrapper;

  color: ${theme.colors.n900};
`

export const Wrapper = styled('div')(wrapperStyles)
export const Section = styled('div')(sectionStyles)
export const Discount = styled(Text)(discountTextStyles)
